import { HttpService } from '@/shared/lib/http'

export class PatchAtualizarClientesService extends HttpService {
  async execute(id: string, cpf: string) {
    const response = await this.http.patch(`api/v2/Cliente/${id}/atualizarCpf`, { cpf })
    return response
  }
}
